import { DatePipe, formatDate, Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

// export const DATE_FORMAT = {
//   parse: {
//     dateInput: "DD-MM-YYYY"
//   },
//   display: {
//     dateInput: "DD/MM/YYYY",
//     monthYearLabel: "MMM YYYY",
//     dateA11yLabel: "DD/MM/YYYY",
//     monthYearA11yLabel: "MMMM YYYY"
//   }
// };

@Component({
  selector: 'app-towalert-report',
  templateUrl: './towalert-report.component.html',
  styleUrls: ['./towalert-report.component.css'],
  // providers: [
  //   {
  //     provide: DateAdapter,
  //     useClass: MomentDateAdapter,
  //     deps: [MAT_DATE_LOCALE]
  //   },
  //   { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
  //   DatePipe
  // ]
})
export class TowAlertReportComponent implements OnInit {

  public matFormSize = '12px';
  public towalertForm: FormGroup;

  public tableData = [];
  public noDataFoundEnable: boolean = false;
  public excelData = {};

  public maxDate = new Date();
  public maxEndDate = new Date();
  public enableAllOption: boolean = false;
  public allVehDownload: boolean;  
  public multiSelectVehicle: boolean = false;
   /* Pagination */
   public showPagination: boolean = true;
   public paginationData = {
       page: 1,
       limit: 10,
       totalPage: 1,
   };

  public showTable: boolean = false;
  public cols: any = [
    { key: '#', display: '#' },
    { key: 'name', display: 'Driver name' ,headerConfig:{ isDefault: true}},
    {
        key: 'vehRegNo', display: 'Reg no',
        config: {
            isVehicle: true,
        },
        headerConfig:{ isDefault: true}
    },
    {key:'date',display:'Time',config: {isDate: true, format: 'dd MMM YYYY hh:mm:ss'}}
];
  public localStorage;
  public errorObject: any = {
    startDate: '',
    endDate: '',
  }
  public formSubmitted: boolean = false;
  addObj: any ={};


  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public storage: StorageService,
    public excel: ExcelExportService,
    public comService: CommonServices,
    public router: Router) {
    this.localStorage = this.storage.get('vendorID_orgID');
    
  }

  ngOnInit(): void {
  }

  getTowAlertReports(obj) {
    this.noDataFoundEnable = false;
    this.showTable = false;
    this.tableData = [];
    this.api.getTowAlertReportList(obj).then((res: any) => {
      if (res && res.data) {
        this.tableData = res.data;
        this.processPagination(res, obj);
      }
      setTimeout(() => { this.showTable = true; this.noDataFoundEnable = true }, 100);
      
     
    }).catch((err) => {
      console.log(err);
    })
  }


  submitForm(formFild) {
  
    let obj;
    if (formFild['formFilds'] !== undefined) {
      obj = {
        // "vehRegNo": [formFild['formFilds']['selectedVehicle']],
        "startDate": new Date(formFild['formFilds']['sDate']).getTime(),
        "endDate": new Date(formFild['formFilds']['eDate']).getTime(),
        limit: 10,
        page: 1
      }
      formFild['formFilds']['selectedVehicle'] ? obj['vehRegNo'] = [formFild['formFilds']['selectedVehicle']] : obj['vehRegNo'] = []
    } else {
      obj = formFild;
    }
    this.addObj = obj;
    this.getTowAlertReports(obj);
  }

  async exportToExcel() {
    let data = [];

    const startDate = this.comService.timestampToDate(this.addObj.startDate,'DMY')
    const endDate = this.comService.timestampToDate(this.addObj.endDate,'DMY')

    let rowCount = 2;
    let endCell = 'D';
    let customizedData = [];
    let titleRow = {
      value: ['Tow-alert Reports'],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },

      },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      alignment: {
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: '966462AF' }
      },
    }

    customizedData.push(titleRow);

    rowCount = rowCount + 2;

    let subtitleRow = {
      value: [
        "Start Date     : " + startDate + "\n" +
        "End Date       : " + endDate + ""
      ],
      font: { name: 'Corbel', family: 4, size: 12 },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
    }

    customizedData.push(subtitleRow);
    rowCount = rowCount + 1;
    let headerRow =
    {
      value: ['S No','Driver name', 'Reg no', 'Date & time'],
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      },
      font: { bold: true },
      border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    }
    customizedData.push(headerRow);


    for (let i = 0; i < this.tableData.length; i++) {
      let item = this.tableData[i];
      try {
        let res = {
          value: [
            i + 1,
            item.name ? item.name : '---',
            item.vehRegNo ? item.vehRegNo.toUpperCase() : '---',
            item.date ? formatDate(item.date, 'dd/MMM/yyyy hh:mm:ss a', 'en-In') : '--/--/---- --:--:-- --',
          ]
        };
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      customizedData = [...customizedData, ...data];

      if (this.excelData['SOS'] == undefined) {
        this.excelData['SOS'] = {};
      }

      this.excelData['SOS'] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 15 }, { colNo: 3, width: 20 }, { colNo: 4, width: 25 }, { colNo: 5, width: 25 }]
        }
      }

      const chunk: any = await this.comService.chunkObject(this.excelData, 50);
      for (let i = 0; i < chunk.length; i++) {
        this.excel.generateExcel(chunk[i], 'Tow-alert_' + 'Reports' + '_' + i + '_' + this.comService.timestampToDate(new Date().getTime(),'DMY' )  + '.xlsx');
      }
    }

  }

  pagination(data) {
   this.addObj['page'] = data['page'],
    this.addObj['limit'] = data['limit'];
    this.submitForm(this.addObj)
  }
  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
        page: req.page,
        limit: req.limit,
        totalPage: this.getTotalCount(data.count, req.limit),
    }
    this.showTable = true;
}
getTotalCount(total, limit) {
  let result: any = 1;
  if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
  }
  return Math.floor(result);
}
}

